import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CHEVRON_DOWN: GlameraIconDefinition = {
  name: 'chevron-down',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-chevron-down-trail" d="m6 9 6 6 6-6"></path>
    <path class="glm-chevron-down-arrow" d="m6 9 6 6 6-6"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-chevron-down-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './chevron-down.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ChevronDownIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CHEVRON_DOWN;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
